import startCase from "lodash/startCase";

export default {
  computed: {
    csrfToken: function () {
      return window.POC.csrfToken()
    }
  },

  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    showToast: function (message, title) {
      this.$bvToast.toast(message, {
        title: title
      })
    },

    assetPublicUrl(asset) {
      // Notice the s - routes is pluralized here
      const type = asset.asset_type || asset.type
      return `/${type.toLowerCase()}s/${asset.slug}/${asset.reference_number_sequence}`;
    },

    assetIcon(asset) {
      if (asset.type === "Photo") {
        return "fas fa-images"
      } else if (asset.type === "Video") {
        return "fas fa-video"
      } else if (asset.type === "Illustration") {
        return "fas fa-pen-nib"
      }
    },

    showErrorToast: function (message, errors) {
      let errorList = [message].concat(this.getErrorMessages(errors));

      const h = this.$createElement;
      const vNodesMsg = h(
        'div',
        errorList.map(e => h('div', e))
      );

      this.$bvToast.toast(vNodesMsg, {
        title: 'Error',
        variant: 'danger'
      })
    },

    isObject: function (object) {
      return object === Object(object);
    },

    isString: function (object) {
      return typeof object === 'string' || object instanceof String;
    },

    getErrorMessages: function (errors, humanizeKey=false) {
      if (!errors) return null;

      let errorList = [];

      if (this.isObject(errors) && errors.body) {
        errors = errors.body;
      }

      if (Array.isArray(errors)) {
        errorList = errorList.concat(errors);
      } else if (this.isString(errors)) {
        errorList.push(errors)
      } else if (this.isObject(errors)) {
        errorList = errorList.concat(Object.keys(errors).map(k => {
          if (k === 'base') {
            return errors[k];
          } else {
            if (Array.isArray(errors[k])) {
              return `${humanizeKey ? startCase(k) : k}: ${errors[k].join(', ')}`;
            } else {
              return `${humanizeKey ? startCase(k) : k}: ${errors[k]}`;
            }
          }
        })).flat()
      }

      return errorList;
    },

    getErrorMessagesHtml: function(errors) {
      const errorList = this.getErrorMessages(errors, true);
      return `<ul class="list-unstyled m-0">${errorList.map(e => `<li>${e}</li>`)}</ul>`
    },

    humanize: function (string) {
      return startCase(string)
    },

    assetUpdatedAtImageUrl(maybeUrl, asset) {
      const updatedAt = asset.updated_at_unix_timestamp || asset.updated_at

      if (!maybeUrl) {
        return null
      }

      let url = new URL(maybeUrl)

      if (!url) {
        return maybeUrl
      }

      if (updatedAt) {
        url.searchParams.append('t', updatedAt)
      }

      return url.toString()
    }
  }
}